import UserDataPlatformSDK from './dist/user-data-platform-sdk';

export default UserDataPlatformSDK;
